import { render, staticRenderFns } from "./Pension.vue?vue&type=template&id=de2c4a50&scoped=true"
import script from "./Pension.vue?vue&type=script&lang=js"
export * from "./Pension.vue?vue&type=script&lang=js"
import style0 from "./Pension.vue?vue&type=style&index=0&id=de2c4a50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de2c4a50",
  null
  
)

export default component.exports